import CONFIG from '@/config/config.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { IntroSteps } from '@/views/process/components/quizInialized/intro/IntroSteps.model.ts';
import IntroSegment1 from '@/views/process/components/quizInialized/intro/segments/IntroSegment1.tsx';
import IntroSegment2 from '@/views/process/components/quizInialized/intro/segments/IntroSegment2.tsx';
import VideoFull from '@/views/process/components/quizInialized/intro/segments/VideoFull.tsx';
import { isSkippableIntroSegment } from '@/views/process/components/quizInialized/skipConfig.ts';
import { FC, useState } from 'react';

interface Props {
  onFinishIntro: () => void;
}

const Intro: FC<Props> = ({ onFinishIntro }) => {
  const isMobile = useMobileMediaQuery();

  const [step, setStep] = useState<IntroSteps>(IntroSteps.SEGMENT_1);

  const handleStep = (newStep: IntroSteps) => () => setStep(newStep);
  const videoSegment1Url = isMobile
    ? `${CONFIG.CDN_VIDEO_URL}/001%20pion_mobile.mp4`
    : `${CONFIG.CDN_VIDEO_URL}/001%20poziom_desktop.mp4`;

  const videoSegment2Url = isMobile
    ? `${CONFIG.CDN_VIDEO_URL}/001-%20Przejscie%20-%209x16.mp4`
    : `${CONFIG.CDN_VIDEO_URL}/001-%20Przejscie.mp4`;

  return {
    [IntroSteps.SEGMENT_1]: (
      <VideoFull
        fullWidth
        handleNext={handleStep(IntroSteps.SEGMENT_2)}
        muted={false}
        showSkip={isSkippableIntroSegment(IntroSteps.SEGMENT_1)}
        videoUrl={videoSegment1Url}
      />
    ),
    [IntroSteps.SEGMENT_2]: (
      <IntroSegment1
        handleNext={handleStep(IntroSteps.SEGMENT_3)}
        showSkip={isSkippableIntroSegment(IntroSteps.SEGMENT_2)}
      />
    ),
    [IntroSteps.SEGMENT_3]: (
      <VideoFull
        fullWidth
        handleNext={handleStep(IntroSteps.SEGMENT_4)}
        muted={false}
        showSkip={isSkippableIntroSegment(IntroSteps.SEGMENT_3)}
        videoUrl={videoSegment2Url}
      />
    ),
    [IntroSteps.SEGMENT_4]: (
      <IntroSegment2
        handleNext={onFinishIntro}
        showSkip={isSkippableIntroSegment(IntroSteps.SEGMENT_4)}
      />
    ),
  }[step];
};

export default Intro;
